import {ModalV3} from "./ModalV3";
import Axios from "axios";
import createElement from "../../createElement";
import handleAjaxError from "../../handleAjaxError";
import {hideLoading, showLoading} from "../../loading";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * Class based version of initial modalV2
 */
class ServerModalV3 extends ModalV3 {
	/**
	 * @param {string} initialRoute
	 * @param {ServerModalV3Defs.Config} [config]
	 */
	constructor(initialRoute, config = {}) {
		super(config);

		// We return a promise that will return the modal instance after
		// it has retrieved the modal's HTML from the server
		return (async () => {
			// Retrieve modal from server and display upon initialization
			showLoading();

			await this.refreshModalFromServer({
				route: initialRoute,
				preserveScroll: false,
				inPlace: false,
			});

			hideLoading();

			this.display(true);

			// Return initialized modal to constructor from promise
			return this;
		})();
	}

	/**
	 * @returns {ServerModalV3Defs.ModalFilters}
	 */
	getFilters() {
		return {}
	}

	getRefreshUrl() {
		const refreshUrl = new URL(
			this.modalContainer.querySelector('input[name="refresh_url"]').value
		);

		// Update filters
		let filters = this.getFilters();

		if (this.config.getFilters) {
			// Merge modal and custom filters
			filters = {
				...filters,
				...this.config.getFilters()
			}
		}

		Object.keys(filters).forEach(key => {
			refreshUrl.searchParams.set(key, filters[key]);
		})

		return refreshUrl.toString();
	}

	/**
	 * @param {ServerModalV3Defs.RefreshModalConfig} config
	 * @returns {Promise<void>}
	 */
	async refreshModalFromServer(config = {}) {

		/** @type {ServerModalV3Defs.RefreshModalConfig} */
		const defaultConfig = {
			inPlace: true,
			route: undefined,
			preserveScroll: false,
			noLoading: false,
		}

		config = {
			...defaultConfig,
			...config,
		}

		let route = config.route;

		if (route === undefined) {
			route = this.getRefreshUrl();
		}

		if (config.noLoading === false) {
			this.showLoadingInModal();
		}

		await Axios.post(route)
			.then(response => {
				this.replace(
					createElement(response.data.modal),
					config.inPlace,
					config.preserveScroll
				);
			})
			.catch(error => {
				handleAjaxError(error);
				// Hide modal if created
				$(this.modalContainer).modal('hide');
			})
			.finally(() => {
				if (config.noLoading === false) {
					this.hideLoadingInModal();
				}
			});
	}
}

export {ServerModalV3}
